import { Button, CIPageHeader, Checkbox, Input, MyIcon } from 'ccs-ui-components';
import { ChangeEvent } from 'react';
import { Col, Row } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import { IFormFieldData } from '../../../../models';
import { ScheduledMaintenanceDetailsForm } from '../scheduled-maintenance-details-form/ScheduledMaintenanceDetailsForm';
import { maintenanceService } from '../scheduled-maintenance-details-wrapper/ScheduledMaintenanceDetailsWrapper';
import classes from '../scheduled-maintenance-details-wrapper/ScheduledMaintenanceDetailsWrapper.module.scss';
import { fetchHeaderTitle, getMaintenanceNameFromUrl, getModeFromUrl } from '../scheduled-maintenance-details-wrapper/utilities/AddScheduleMaintenanceUtils';

export interface IImpactedServicesForm {
  cancelHandler: () => void;
  isView: boolean;
  isEdit: boolean;
  disableSave: boolean;
  isDisable: boolean;
  saveMaintenanceHandler: () => void;
  handleFormData: (data: IFormFieldData) => void;
  searchValue: string;
  getServices: (e: ChangeEvent<HTMLInputElement>) => void;
  isViewServices: boolean;
  invalidMaintenanceService: maintenanceService;
  services: any[];
  handleSelect: (data: any, event: React.FormEvent<HTMLInputElement>) => void;
  selArray: any[];
  handleDelete: (data: any) => void;
  isLoading: boolean;
  errorText: () => string;
  handleEdit: () => void;
  isSticky: boolean;
  headerText: string;
  enableUpdateButton: boolean
}
const ImpactedServicesForm = (props: IImpactedServicesForm) => {
  const { t: translate } = useTranslation();
  const { cancelHandler, isView, isEdit, disableSave, isDisable, enableUpdateButton, saveMaintenanceHandler, handleFormData, searchValue, getServices, isViewServices, isLoading, invalidMaintenanceService, errorText, services, handleSelect, selArray, handleDelete, isSticky, headerText, handleEdit } = props;

  const maintenanceNameFromUrl = getMaintenanceNameFromUrl();
  const maintenanceModeFromUrl = getModeFromUrl();
  const text = translate('add_sm_service.txt_maintenance_header');

  const renderButtons = () => {
    if (isView) {
      return (
        <Button
          variant="primary"
          onClick={handleEdit}
          data-testid="saveBtn"
        >
          {translate('add_sm_service.txt_edit')}
        </Button>
      );
    }
    if (isEdit) {
      return (
        <Button
          disabled={disableSave || isDisable || enableUpdateButton}
          variant="primary"
          onClick={saveMaintenanceHandler}
          data-testid="saveBtn"
        >
          {translate('add_sm_service.txt_update')}
        </Button>
      );
    }
    return (
      <Button
        disabled={disableSave || isDisable}
        variant="primary"
        onClick={saveMaintenanceHandler}
        data-testid="saveBtn"
      >
        {translate('add_sm_service.txt_create')}
      </Button>
    );
  };

  return (
    <>
      <Row>
        <Col
          md={{ offset: 1, span: 10 }}
          className={classes['add-ScheduledMaintenance-header-container-wrapper']}
        >
          <div className={`${isSticky ? classes['sticky-header'] : ''}`} data-testid={isSticky ? 'sticky-header' : 'no-sticky'}>
            <div className={classes['add-ScheduledMaintenance-header-container']}>
              <div>
                <CIPageHeader header={`${fetchHeaderTitle(maintenanceNameFromUrl, maintenanceModeFromUrl, headerText, text)}`} className={`${isSticky ? classes['sticky-header-title'] : ''}`} />
                <span className={`${isSticky ? classes['sticky-header-subtitle'] : ''}`} data-testid={isSticky ? 'sticky-header-subtitle' : 'no-sticky-header-subtitle'}>
                  {translate('add_sm_service.txt_maintenance_desc')}
                </span>
              </div>
              <div className={`${classes['add-ScheduledMaintenanc-last-buttonts-holder']} ci-button-group`}>
                <Button
                  variant="secondary"
                  onClick={cancelHandler}
                  data-testid="cancel-btn"
                  aria-label="cancel-btn"
                >
                  {translate('add_sm_service.txt_cancel')}
                </Button>
                {renderButtons()}
              </div>
            </div>
          </div>
        </Col>
      </Row>
      <Row>
        <Col
          className={`form-wrapper-container ${classes['add-AddScheduledMaintenance-form-container']}`}
          md={{ offset: 1, span: 10 }}
        >
          <ScheduledMaintenanceDetailsForm
            handleFormData={handleFormData}
          />
          <hr />
          <Row className={classes['add-ScheduledMaintenanc-form-row']}>
            <Col md={4} className="no-padding">
              <div
                className={
                  classes['add-ScheduledMaintenanc-form-container-col-title']
                }
              >
                {translate('add_sm_service.txt_impacted_services')}
              </div>
              <div
                className={
                  classes['add-ScheduledMaintenanc-form-container-col-sub-title']
                }
                data-testid="detailcomp"
              >
                {translate('add_sm_service.txt_impacted_services_desc')}
              </div>
            </Col>
            <Col
              md={7}
              className={classes['add-ScheduledMaintenanc-impacted-service-col']}
            >
              <Row
                className={classes['add-ScheduledMaintenanc-impacted-service-row']}
              >
                <Col md={6}>
                  <div
                    className={classes['add-ScheduledMaintenanc-form-searchinput']}
                  >
                    <Input
                      label={undefined}
                      helperText={String(translate('add_sm_service.txt_search_helper'))}
                      value={isView ? '' : searchValue}
                      onChange={getServices}
                      placeholder={String(translate('add_sm_service.txt_search_placeholder'))}
                      disabled={isView || isViewServices}
                      isLoading={isLoading}
                      name=""
                      error={invalidMaintenanceService !== maintenanceService.VALID}
                      errorTxt={errorText()}
                    />
                  </div>
                  <div
                    data-testid="services-holder"
                    className={classes['services-holder']}
                  >
                    {!isView && services?.map((data: any) => (
                      <>
                        <Row
                          key={data.serviceName}
                          className={classes['add-ScheduledMaintenanc-service-col']}
                        >
                          <Col
                            md={1}
                            className={
                              classes['add-ScheduledMaintenanc-service-check-box']
                            }
                          >
                            <Checkbox
                              onClick={(event: React.FormEvent<HTMLInputElement>) =>
                                handleSelect(data, event)}
                              checked={data.isChecked}
                              data-testid="check-service"
                            />
                          </Col>
                          <Col
                            md={11}
                            className={
                              classes['add-ScheduledMaintenanc-service-header-col']
                            }
                          >
                            <div
                              className={
                                classes['add-ScheduledMaintenanc-service-header']
                              }
                              data-testid="serviceName"
                            >
                              {data?.serviceName}
                              <span
                                className={
                                  classes['add-ScheduledMaintenanc-service-version']
                                }
                              >({translate('add_sm_service.txt_service_version', {
                                replace: {
                                  version: data?.version
                                }
                              })})
                              </span>
                            </div>
                            <div
                              className={
                                classes[
                                'add-ScheduledMaintenanc-service-sub-header'
                                ]
                              }
                            >
                              {data.serviceDescription}
                            </div>
                            <Row
                              className={
                                classes['add-ScheduledMaintenanc-service-detail']
                              }
                            >
                              <Col
                                md={6}
                                className={
                                  classes[
                                  'add-ScheduledMaintenanc-service-type-col'
                                  ]
                                }
                              >
                                <span
                                  className={
                                    classes[
                                    'add-ScheduledMaintenanc-service-type-header'
                                    ]
                                  }
                                >
                                  {translate('add_sm_service.txt_service_type')}
                                </span>
                                <span
                                  className={
                                    classes['add-ScheduledMaintenanc-service-type']
                                  }
                                >
                                  {data.serviceType}
                                </span>
                              </Col>
                              <Col
                                md={6}
                                className={
                                  classes['add-ScheduledMaintenanc-endpoint-col']
                                }
                              >
                                <span
                                  className={
                                    classes[
                                    'add-ScheduledMaintenanc-endpoint-header'
                                    ]
                                  }
                                >
                                  {translate('add_sm_service.txt_endpoint')}
                                </span>
                                <span
                                  className={
                                    classes['add-ScheduledMaintenanc-endpoint']
                                  }
                                >
                                  {data.endPoint}
                                </span>
                              </Col>
                            </Row>
                          </Col>
                        </Row>
                        <hr />
                      </>
                    ))}
                  </div>
                </Col>
                <Col
                  md={6}
                  className={
                    classes['add-ScheduledMaintenanc-impacted-service-sel-col']
                  }
                >
                  <div
                    className={
                      classes['add-ScheduledMaintenanc-impacted-service-sel-header']
                    }
                  >
                    <span
                      className={
                        classes[
                        'add-ScheduledMaintenanc-impacted-service-sel-header-comp'
                        ]
                      }
                    >
                      *
                    </span>
                    {translate('add_sm_service.txt_selected_service')} ({selArray?.length})
                  </div>
                  {selArray?.map((data: any) => (
                    <Row
                      key={(data?.serviceVersion || '') + (data?.serviceName || '')}
                      className={
                        classes['add-ScheduledMaintenanc-impacted-service-sel-item']
                      }
                    >
                      <Col
                        md={11}
                        className={
                          classes[
                          'add-ScheduledMaintenanc-impacted-service-sel-item-col'
                          ]
                        }
                      >
                        <div
                          className={
                            classes['add-ScheduledMaintenanc-impacted-service-sel-item-desc']
                          }
                          title={data?.serviceName}
                        >
                          {data?.serviceName}
                        </div>
                        <div
                          className={
                            classes[
                            'add-ScheduledMaintenanc-impacted-service-sel-item-type'
                            ]
                          }
                        >
                          {translate('add_sm_service.txt_service_version', {
                            replace: {
                              version: data?.serviceVersion
                            }
                          })}
                        </div>
                      </Col>
                      <Col
                        md={1}
                        className={
                          classes[
                          'add-ScheduledMaintenanc-impacted-service-sel-item-col'
                          ]
                        }
                      >
                        {!isView && (
                          <Button
                            variant="tertiary"
                            className={classes['delete-role-btn']}
                            onClick={() => handleDelete(data)}
                            data-testid="delete-role"
                          >
                            <MyIcon name="deleteIcon" />
                          </Button>
                        )}
                      </Col>
                    </Row>
                  ))}
                </Col>
              </Row>
            </Col>
          </Row>
        </Col>
      </Row>
    </>
  );
};
export default ImpactedServicesForm;
